module.exports = __webpack_public_path__ + "img/dollar.32767845.svg";